import React from 'react';
import {InspectionsMap} from '../components/InspectionsMap';
import {StreetsProvider} from '../../_common/components/CitiesAndStreets';
import {InspectionsMapFiltersProvider, InspectionsMapProvider} from '../context';
import {InspectionMapFilters} from '../components/InspectionMapFilters';
import SubheaderBar from '../../_common/components/SubheaderBar';

export const InspectionsMapPage = () => {

  return (
    <StreetsProvider>
      <InspectionsMapProvider>
        <InspectionsMapFiltersProvider>
          <SubheaderBar>
            <InspectionMapFilters/>
          </SubheaderBar>
        </InspectionsMapFiltersProvider>
        <InspectionsMap/>
      </InspectionsMapProvider>
    </StreetsProvider>
  );
};